import React, { useState, useEffect, Suspense } from "react";
import {
  Container,
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from "@material-ui/core";
import { useImage } from "react-image";
import { useQuery } from "@apollo/client";
import { GET_MATERIAL_IMAGES_BY_SUB_CATEGORY_ID } from "../../../../../quries/material";
import Masonry from "react-masonry-css";
import styled from "styled-components";

import Lightbox from "react-image-lightbox";
import LaborIssueImageMasonryGird from "./LaborIssueImageMasonryGird";

interface LaborIssueImagesLayoutProps {
  //   rowData: any;
  imgArr: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    videoBigTitle: {
      fontSize: 24,
      fontWeight: 900,
      fontFamily: "Noto Sans KR",
      paddingBottom: 16,
      [theme.breakpoints.down("xs")]: { paddingBottom: 8 },
    },
    imgContainer: {
      [theme.breakpoints.down("xs")]: { padding: 0 },
    },
  })
);

function LaborIssueImagesLayout({ imgArr }: LaborIssueImagesLayoutProps) {
  const classes = useStyles();
  const [imgArray, setImgArray] = useState<any>(null);
  const [imgIndex, setImgIndex] = useState<number>(0);
  const [isOpen, setIsOpen] = useState<Boolean>(false);

  useEffect(() => {
 
    setImgArray(imgArr);

    return () => {
      setImgArray(null);
    };
  }, [imgArr]);

  return (
    <Container maxWidth={false} disableGutters={true}>
      <Grid
        alignItems="center"
        justify="center"
        xs={12}
        container
        item
        className={classes.imgContainer}
      >
        {imgArray ? (
          <React.Fragment>
            <Grid xs={12} item>
              <p className={classes.videoBigTitle}>사진 자료</p>
            </Grid>

            {imgArray && imgArray.length > 0 ? (
              imgArray.map((element: any, index: any) => {
                
                return (
                  <LaborIssueImageMasonryGird
                    element={element}
                    key={`citzen-image-material-${index}`}
                  />
                );
              })
            ) : (
              <div></div>
            )}
          </React.Fragment>
        ) : (
          <div></div>
        )}
      </Grid>
    </Container>
  );
}
export default LaborIssueImagesLayout;
